import cacheService from '../../../services/cacheService';
import { apiV2Client } from '../../../services/apiClient';
import { IsV2Response } from '../models/assessment';

export const checkAssessmentIsV2 = (assessmentId: string): Promise<IsV2Response> => {
  const endpoint = `/assessment/isV2/${assessmentId}`;
  const cached = cacheService.get(endpoint);
  if (cached) return Promise.resolve(cached);

  return apiV2Client.get<IsV2Response>(endpoint).then(({ data }) => {
    cacheService.set(endpoint, data, 5);
    return data;
  });
};
